// on scroll event add class to header
let scrollpos = window.scrollY;

var header = document.querySelector(".site-header");
var scrollChange = 30;

if (header) {
  window.addEventListener("scroll", function () {
    scrollpos = window.scrollY;
    if ( scrollpos >= scrollChange && header.classList.contains("site-header--fixed")) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  });
}
